<p class="mb-3 text-lg text-grey" *ngIf="title">
  {{ title }}
</p>

<ul>
  <ng-container *ngFor="let link of links; let isFirst = first">
    <li *ngIf="!link.isDisabled" [class.mt-3]="!isFirst">
      <a
        [routerLink]="link.path"
        class="flex items-center font-condensed font-bold lg:px-3"
      >
        <span class="flex flex-col overflow-hidden">
          {{ link.text }}

          <span
            class="font-regular text-xs truncate"
            [ngClass]="link.data ? 'text-grey' : 'text-red'"
          >
            <ng-container *ngIf="link.data">
              {{ link.data }}
            </ng-container>

            <ng-container *ngIf="!link.data">
              {{ 'organizer.edit_activity.draft.to_define' | translate }}
              <span
                *ngIf="link.isOptional"
                class="font-regular text-xs truncate text-grey"
              >
                ({{ 'organizer.edit_activity.draft.optional' | translate }})
              </span>
            </ng-container>
          </span>
        </span>

        <vtmn-play-icon
          class="ml-auto text-3xl"
          [name]="iconType.ArrowRight"
        ></vtmn-play-icon>
      </a>
    </li>
  </ng-container>
</ul>
